import { SVGProps } from "react";

export default function SvgComponent(
  props: SVGProps<SVGSVGElement>
): React.ReactElement {
  return (
    <svg
      width={405}
      height={121}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="a"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={405}
        height={121}
      >
        <path
          transform="matrix(1 0 0 -1 .5 120.619)"
          fill="#F7F7F4"
          d="M0 0h404v120.619H0z"
        />
      </mask>
      <g mask="url(#a)">
        <g filter="url(#b)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M108.542 34.879c-9.898 0-17.92 8.023-17.92 17.92v105.123c0 .161.001.322.005.482h258.664c.004-.16.006-.321.006-.482V52.799c0-9.897-8.023-17.92-17.92-17.92H108.542Z"
            fill="#fff"
          />
        </g>
        <g filter="url(#c)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M99.807 17.44c-9.897 0-17.92 8.023-17.92 17.92v105.123c0 .161.002.322.006.482h258.664c.004-.16.006-.321.006-.482V35.36c0-9.897-8.023-17.92-17.921-17.92H99.807Z"
            fill="#fff"
          />
        </g>
        <g filter="url(#d)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M91.089 0C81.19 0 73.168 8.025 73.168 17.922v105.123c0 .161.002.322.006.482h258.664c.004-.16.006-.321.006-.482V17.921c0-9.897-8.023-17.92-17.92-17.92H91.089Z"
            fill="#fff"
          />
        </g>
        <rect
          x={102.232}
          y={45.545}
          width={200.141}
          height={13.178}
          rx={6.589}
          fill="#DAF4EA"
        />
        <rect
          x={131.875}
          y={23.556}
          width={143.311}
          height={13.178}
          rx={6.589}
          fill="#F0F0ED"
        />
        <rect
          x={130.57}
          y={73.389}
          width={144.331}
          height={31.173}
          rx={15.586}
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M140.681 83.847a7.237 7.237 0 0 0-2.119 5.128 7.267 7.267 0 0 0 12.395 5.148l.02-.02a7.233 7.233 0 0 0 2.118-5.128 7.266 7.266 0 0 0-12.414-5.128Zm.697 1.982a5.45 5.45 0 0 0 7.597 7.597l-7.597-7.597Zm8.885 6.315-7.604-7.603a5.45 5.45 0 0 1 7.604 7.603Z"
          fill="#000"
        />
        <path
          d="M160.389 94.475v-11.19h1.343v4.94h5.803v-4.94h1.343v11.19h-1.343v-5.147h-5.803v5.147h-1.343Zm11.585-9.687a.942.942 0 0 1-.671-.256.944.944 0 0 1-.256-.671.87.87 0 0 1 .256-.64.942.942 0 0 1 .671-.256c.256 0 .475.086.656.256.181.17.272.384.272.64 0 .266-.091.49-.272.67a.923.923 0 0 1-.656.257Zm-.671 9.687v-7.929h1.343v7.929h-1.343Zm7.278.192c-.789 0-1.482-.181-2.079-.544a3.772 3.772 0 0 1-1.374-1.486c-.32-.63-.48-1.343-.48-2.142 0-.8.165-1.508.496-2.127a3.66 3.66 0 0 1 1.374-1.47c.587-.362 1.279-.544 2.079-.544.65 0 1.225.133 1.726.4.501.266.89.64 1.167 1.119v-4.908h1.343v11.51h-1.215l-.128-1.31c-.256.383-.623.73-1.103 1.038-.48.31-1.082.464-1.806.464Zm.143-1.167c.533 0 1.002-.123 1.407-.368.416-.256.736-.607.959-1.055.235-.448.352-.97.352-1.567 0-.596-.117-1.118-.352-1.566a2.44 2.44 0 0 0-.959-1.04c-.405-.255-.874-.383-1.407-.383-.522 0-.991.128-1.406.384a2.583 2.583 0 0 0-.959 1.039c-.224.448-.336.97-.336 1.566 0 .597.112 1.12.336 1.567.234.448.554.8.959 1.055.415.245.884.368 1.406.368Zm9.862 1.167c-.756 0-1.428-.17-2.014-.512a3.804 3.804 0 0 1-1.39-1.454c-.331-.618-.496-1.348-.496-2.19 0-.832.165-1.556.496-2.174a3.55 3.55 0 0 1 1.374-1.455c.597-.352 1.284-.528 2.062-.528.768 0 1.428.176 1.983.528.564.34.996.794 1.294 1.359a3.836 3.836 0 0 1 .432 2.174v.4h-6.314c.032.607.17 1.113.415 1.518.256.394.571.693.944.895.383.203.788.304 1.214.304.555 0 1.018-.128 1.391-.384s.645-.602.815-1.039h1.327a3.6 3.6 0 0 1-1.231 1.839c-.596.479-1.364.719-2.302.719Zm0-7.178a2.69 2.69 0 0 0-1.71.592c-.49.383-.773.948-.847 1.694h4.987c-.032-.714-.277-1.273-.735-1.678-.458-.405-1.023-.608-1.695-.608Zm13.412 7.178c-.756 0-1.439-.17-2.046-.512a3.887 3.887 0 0 1-1.423-1.454c-.341-.63-.511-1.36-.511-2.19 0-.832.17-1.556.511-2.174a3.737 3.737 0 0 1 1.423-1.455c.607-.352 1.29-.528 2.046-.528.938 0 1.727.245 2.366.736.65.49 1.06 1.145 1.231 1.966h-1.375a1.733 1.733 0 0 0-.783-1.135c-.416-.277-.901-.416-1.455-.416-.447 0-.868.112-1.263.336-.394.224-.714.56-.959 1.007-.245.448-.368 1.002-.368 1.662 0 .661.123 1.215.368 1.663.245.448.565.789.959 1.023.395.224.816.336 1.263.336.554 0 1.039-.133 1.455-.4.415-.277.677-.666.783-1.167h1.375c-.16.8-.565 1.45-1.215 1.95-.65.501-1.444.752-2.382.752Zm9.085 0c-.746 0-1.417-.17-2.014-.512a3.768 3.768 0 0 1-1.423-1.438c-.341-.63-.511-1.364-.511-2.207 0-.841.175-1.571.527-2.19a3.738 3.738 0 0 1 1.423-1.454 4.073 4.073 0 0 1 2.03-.512c.746 0 1.417.17 2.014.512a3.627 3.627 0 0 1 1.407 1.454c.352.619.527 1.349.527 2.19 0 .843-.175 1.578-.527 2.207a3.733 3.733 0 0 1-1.439 1.438c-.597.341-1.268.512-2.014.512Zm0-1.151c.458 0 .885-.112 1.279-.336.394-.224.714-.56.959-1.007.245-.448.368-1.002.368-1.663 0-.66-.123-1.214-.368-1.662-.234-.448-.549-.783-.943-1.007a2.52 2.52 0 0 0-1.263-.336c-.458 0-.885.112-1.279.336-.394.224-.714.56-.959 1.007-.245.448-.368 1.002-.368 1.662 0 .661.123 1.215.368 1.663.245.448.559.783.943 1.007.394.224.815.336 1.263.336Zm5.847.959v-7.929h1.215l.096 1.151a2.688 2.688 0 0 1 1.023-.991 2.937 2.937 0 0 1 1.439-.352c.629 0 1.167.128 1.615.384.458.256.81.645 1.055 1.167.277-.48.655-.858 1.135-1.135a3.16 3.16 0 0 1 1.582-.416c.949 0 1.705.288 2.27.864.565.564.847 1.438.847 2.621v4.636h-1.326v-4.492c0-.82-.166-1.439-.496-1.854-.33-.416-.805-.624-1.423-.624-.639 0-1.172.25-1.598.752-.416.49-.624 1.193-.624 2.11v4.108h-1.342v-4.492c0-.82-.166-1.439-.496-1.854-.33-.416-.805-.624-1.423-.624-.629 0-1.156.25-1.582.752-.416.49-.624 1.193-.624 2.11v4.108h-1.343Zm14.3 3.517V86.546h1.215l.128 1.31c.256-.383.618-.73 1.087-1.038.479-.31 1.087-.464 1.822-.464.789 0 1.476.181 2.062.544a3.659 3.659 0 0 1 1.359 1.487c.331.628.496 1.342.496 2.141 0 .8-.165 1.514-.496 2.143a3.655 3.655 0 0 1-1.375 1.47c-.586.352-1.273.528-2.062.528-.65 0-1.231-.133-1.742-.4a2.773 2.773 0 0 1-1.151-1.119v4.844h-1.343Zm4.092-4.492c.533 0 1.002-.123 1.407-.368a2.7 2.7 0 0 0 .959-1.055c.235-.448.352-.97.352-1.567 0-.596-.117-1.118-.352-1.566a2.583 2.583 0 0 0-.959-1.04c-.405-.255-.874-.383-1.407-.383-.532 0-1.001.128-1.406.384a2.583 2.583 0 0 0-.959 1.039c-.235.448-.352.97-.352 1.566 0 .597.117 1.12.352 1.567.234.448.554.8.959 1.055.405.245.874.368 1.406.368Zm8.584 1.167c-.661 0-1.21-.112-1.647-.336-.437-.224-.762-.522-.975-.895a2.409 2.409 0 0 1-.32-1.215c0-.81.309-1.433.927-1.87.618-.437 1.46-.656 2.526-.656h2.142V89.6c0-.692-.181-1.215-.543-1.566-.363-.363-.848-.544-1.455-.544-.522 0-.975.133-1.359.4-.373.256-.607.634-.703 1.135h-1.375c.053-.576.245-1.06.576-1.455a3.259 3.259 0 0 1 1.262-.895 4.042 4.042 0 0 1 1.599-.32c1.108 0 1.94.299 2.494.895.565.587.847 1.37.847 2.35v4.876h-1.199l-.08-1.423a3.185 3.185 0 0 1-.991 1.151c-.426.31-1.002.464-1.726.464Zm.207-1.135c.512 0 .949-.133 1.311-.4a2.52 2.52 0 0 0 .847-1.039c.192-.426.288-.874.288-1.343v-.016h-2.03c-.789 0-1.348.139-1.679.416a1.258 1.258 0 0 0-.479 1.007c0 .416.149.751.448 1.007.309.245.74.368 1.294.368Zm5.803.943v-7.929h1.215l.08 1.423c.256-.501.624-.895 1.103-1.183a3.109 3.109 0 0 1 1.631-.432c.938 0 1.684.288 2.238.864.565.564.847 1.438.847 2.621v4.636h-1.343v-4.492c0-1.652-.682-2.478-2.046-2.478-.682 0-1.252.25-1.71.752-.448.49-.672 1.193-.672 2.11v4.108h-1.343Zm9.777 3.517 1.967-4.284h-.464l-3.149-7.162h1.455l2.621 6.17 2.782-6.17h1.391L261.1 97.992h-1.407Z"
          fill="#000"
        />
        <rect
          x={130.57}
          y={73.389}
          width={144.331}
          height={31.173}
          rx={15.586}
          stroke="#E1E1DB"
          strokeWidth={1.453}
        />
      </g>
      <defs>
        <filter
          id="b"
          x={57.02}
          y={1.278}
          width={334.838}
          height={199.688}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius={4.48}
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_64_6136"
          />
          <feOffset dx={4.48} dy={4.48} />
          <feGaussianBlur stdDeviation={16.801} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.682353 0 0 0 0 0.682353 0 0 0 0 0.752941 0 0 0 0.4 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_64_6136"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_64_6136"
            result="shape"
          />
        </filter>
        <filter
          id="c"
          x={48.286}
          y={-16.162}
          width={334.838}
          height={199.688}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius={4.48}
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_64_6136"
          />
          <feOffset dx={4.48} dy={4.48} />
          <feGaussianBlur stdDeviation={16.801} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.682353 0 0 0 0 0.682353 0 0 0 0 0.752941 0 0 0 0.4 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_64_6136"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_64_6136"
            result="shape"
          />
        </filter>
        <filter
          id="d"
          x={39.567}
          y={-33.6}
          width={334.838}
          height={199.688}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius={4.48}
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_64_6136"
          />
          <feOffset dx={4.48} dy={4.48} />
          <feGaussianBlur stdDeviation={16.801} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.682353 0 0 0 0 0.682353 0 0 0 0 0.752941 0 0 0 0.4 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_64_6136"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_64_6136"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
